import React, { Fragment, useState, useRef, useEffect } from 'react'
import { Col, Card, Row, Input } from 'reactstrap';
import { Progress } from "reactstrap";
import { Bar } from "react-chartjs-2";
import { Pie } from "react-chartjs-2";
import { Doughnut } from "react-chartjs-2";
import { useReportCompany } from '../../../hooks/Pbi/useReportCompany';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Line } from "react-chartjs-2";
import { Tag } from 'primereact/tag';
import Select from 'react-select';







export const IndexReportCompany = () => {

    const {
        countExams,
        countProfiles,
        dataViewCompany,
        dateStart, dateEnd,
        setDateStart, setDateEnd,
        loadingIdR,
        handleFilterByClient,
        handleCleanFilterByClient,
        handleFilterDate,
        loadingReport,
        ReportCompanyChart,
        detailTransactionsByCompany,
        viewDetailCompany,
        filterId,
        handleChangeAgreement,
        listAgreement,
        valuId,
        DownloadReportCxc,
        listCompanies,
        handleChangeCompany,
        id_company,
        globalFilter, setGlobalFilter





    } = useReportCompany();
    console.log("🚀 ~ IndexReportCompany ~ valuId:", valuId)


    // * STYLES DATA TABLE
    const headerStyle =
    {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle =
    {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",
    };

    const centerStyle =
    {
        ...cellStyle,
        textAlign: "center",
        zIndex: 2
    };


    const dataBar = {
        labels: ["Perfiles", "Examenes"],
        datasets: [
            {
                label: "Estudios",
                data: [
                    countProfiles,
                    countExams,

                ],
                backgroundColor: ["#6c757d", "#1d5b83", "#17a2b8"],
                borderRadius: 8,
            },
        ],
    };

    const optionsBar = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { display: false } },
        scales: {
            x: { grid: { display: false } },
            y: { grid: { display: false }, ticks: { stepSize: 5 } },
        },
    };



    const getButtonStyle = (bgColor) => ({
        width: "26px",
        height: "26px",
        fontSize: "0.65rem",
        borderRadius: "8px",
        padding: "0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "none",
        color: "#fff",
        cursor: "pointer",
        backgroundColor: bgColor,
    });

    const buttonStyle = getButtonStyle("#f97316");
    const buttonStyle2 = getButtonStyle("#16A34A");


    const [expandedRows, setExpandedRows] = useState([]);

    useEffect(() => {
        const initialExpandedRows = detailTransactionsByCompany.filter(
            item => item.detailTransactionsByProfileOrExams?.length > 1
        );
        console.log("🚀 ~ IndexReportCompany ~ initialExpandedRows:", initialExpandedRows)
        setExpandedRows(initialExpandedRows);
    }, [detailTransactionsByCompany]);




    const rowExpansionTemplate = (row) => {
        if (!row.detailTransactionsByProfileOrExams || row.detailTransactionsByProfileOrExams.length <= 1) {
            return null;
        }

        return (
            <div className="p-3">
                <h6 className="mb-2">Estudios detallados</h6>
                <ul className="studies-list">
                    {row.detailTransactionsByProfileOrExams?.map((study, i) => (
                        <li key={i}>{study.nameStudy}</li>
                    ))}
                </ul>
            </div>
        );
    };
    let typeMenu = localStorage.getItem('menu') === "True";
    
    return (
        <Col sm="12" className={`container-global-zoom ${typeMenu ? "p-4" : ""}`} >
            <Row className=" align-items-stretch p-card-microsite">
                <Col sm="12"  >
                    <span
                        style={{
                            position: "absolute",
                            top: "-20px",
                            left: "50%",
                            transform: "translateX(-50%)",
                            backgroundColor: "#006d97",
                            color: "#fff",
                            padding: "6px 25px",
                            borderRadius: "25px",
                            fontWeight: 700,
                            fontSize: "12px",
                            boxShadow: "rgba(0, 0, 0, 0.25) 0px 4px 12px",
                            zIndex: 2,
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            cursor: "default"
                        }}
                    >
                        Estudios por empresa
                    </span>
                    <Row>
                        <Col sm={filterId === 0 ? "6" : "4"} className='' >

                            {/* <Col sm="12">
                                <h5 className='f-w-600' style={{ color: "#0d3b59" }}>Clientes</h5>

                            </Col> */}
                            <Col sm="12">
                                <Row className="align-items-center mt-2">
                                    <Col sm={filterId !== 0 ? "Fe4" : "3"}>
                                        <label className='label-dashboard' style={{ color: "#0d3b59", fontSize: "14px" }}>Inicio</label>
                                        <Input
                                            type="date"
                                            value={dateStart}
                                            onChange={(e) => setDateStart(e.target.value)}
                                            className="mr-2"
                                        />
                                    </Col>
                                    <Col sm={filterId !== 0 ? "4" : "3"}  >
                                        <label className='label-dashboard' style={{ color: "#0d3b59", fontSize: "14px" }}>Fin</label>
                                        <Input
                                            type="date"
                                            value={dateEnd}
                                            onChange={(e) => setDateEnd(e.target.value)}
                                            className="mr-2"
                                        />
                                    </Col>
                                    <Col sm="4" className={filterId !== 0 ? "d-none" : "pt-3"} >
                                        <label className='label-dashboard' style={{ color: "#0d3b59", fontSize: "14px" }}>Empresa</label>
                                        <div className='form-group'>
                                            <Select
                                                classNamePrefix="select"
                                                className="input-air-primary input-xs"
                                                name="id_company"
                                                value={id_company}
                                                placeholder="Selecciona una empresa"
                                                options={listCompanies}
                                                onChange={handleChangeCompany}
                                                isClearable={true}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                                }}
                                            />

                                        </div>

                                    </Col>
                                    <Col sm="1" className={filterId !== 0 ? "d-none" : "d-none"}>
                                    </Col>

                                    <Col sm={filterId !== 0 ? "3" : "2"} className='pt-4' >
                                        <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                                            <Button
                                                icon="pi pi-search"
                                                rounded
                                                severity="success"
                                                aria-label="Search"
                                                onClick={handleFilterDate}
                                                style={{
                                                    padding: "5px 10px",
                                                    height: "35px",
                                                    width: "35px",
                                                    fontSize: "1rem",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}
                                                className={filterId !== 0 ? "d-none" : ""}
                                            // disabled={loadingView1 ? true : false}

                                            />
                                            <button
                                                className="p-button p-button-danger"
                                                title="Limpiar filtro"
                                                style={{
                                                    alignItems: "center",
                                                    padding: "5px 8px",
                                                    height: "35px",
                                                    width: "35px",
                                                    fontSize: "0.9rem",
                                                    display: "flex",
                                                    justifyContent: "center"
                                                }}
                                                //disabled={loadingView1 ? true : false}
                                                onClick={() => handleCleanFilterByClient()}

                                            >
                                                <i className="pi pi-trash" style={{ fontSize: "1rem" }}></i>
                                            </button>
                                            {
                                                filterId === 0 && <>
                                                    {loadingIdR === 0 ? (
                                                        <i className="fa fa-spin fa-circle-o-notch f-24 txt-success"></i>
                                                    ) : (
                                                        <button
                                                            className="p-button p-button-success"
                                                            onClick={() => DownloadReportCxc(null, 0)}
                                                            title="Reporte Mensual de las empresas"
                                                            style={{
                                                                alignItems: "center",
                                                                padding: "5px 8px",
                                                                height: "35px",
                                                                width: "35px",
                                                                fontSize: "0.9rem",
                                                            }}
                                                        //disabled={loadingView1 ? true : false}

                                                        >
                                                            <i className="pi pi-file-excel" style={{ fontSize: "1rem", marginRight: "5px" }}></i>
                                                        </button>
                                                    )}

                                                </>
                                            }
                                            {
                                                filterId !== 0 && <>
                                                    {loadingIdR === 0 ? (
                                                        <i className="fa fa-spin fa-circle-o-notch f-24 txt-success"></i>
                                                    ) : (
                                                        <button
                                                            className="p-button p-button-success"
                                                            onClick={() => DownloadReportCxc(filterId, valuId,)}
                                                            title="Reporte Mensual de las empresas"
                                                            style={{
                                                                alignItems: "center",
                                                                padding: "5px 8px",
                                                                height: "35px",
                                                                width: "35px",
                                                                fontSize: "0.9rem",
                                                            }}
                                                        //disabled={loadingView1 ? true : false}

                                                        >
                                                            <i className="pi pi-file-excel" style={{ fontSize: "1rem", marginRight: "5px" }}></i>
                                                        </button>
                                                    )}
                                                </>
                                            }

                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col sm="12" className={filterId !== 0 ? "d-none" : 'pt-2'}  >
                                <DataTable
                                    value={dataViewCompany}
                                    responsiveLayout="scroll"
                                    paginator
                                    rows={10}
                                    emptyMessage={
                                        <div className="text-center">
                                            <img
                                                src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                style={{ width: "25%" }}
                                                alt="Sin Muestras"
                                            />
                                            <br />
                                            <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                No hay resultados disponibles.
                                            </p>
                                        </div>
                                    }
                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                    stripedRows
                                    globalFilter={globalFilter}
                                    loading={loadingReport}
                                >
                                    <Column
                                        body={(rowData, { rowIndex }) => rowIndex + 1}
                                        header="#"
                                        headerStyle={{ ...headerStyle, textAlign: "center" }}
                                        style={{
                                            ...cellStyle,
                                            textAlign: "center",
                                            width: "100px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            verticalAlign: "top",
                                            paddingBottom: 0,
                                        }}
                                        sortable
                                        field="id_client"
                                    />
                                    <Column
                                        headerStyle={headerStyle}
                                        header="Cliente"
                                        body={(row) => (
                                            <>

                                                {row.name_client ?? "--"}

                                            </>
                                        )}
                                        style={centerStyle}
                                        sortable
                                        field="name_client"
                                    />
                                    <Column
                                        headerStyle={headerStyle}
                                        header="Total de examenes"
                                        body={(row) => (
                                            <>

                                                {row.total_exams ?? "--"}

                                            </>
                                        )}
                                        style={centerStyle}
                                        sortable
                                        field="total_exams"
                                    />
                                    <Column
                                        headerStyle={headerStyle}
                                        header="Total de perfiles"
                                        body={(row) => (
                                            <>

                                                {row.total_profiles ?? "--"}

                                            </>
                                        )}
                                        style={centerStyle}
                                        sortable
                                        field="total_profiles"
                                    />
                                    <Column
                                        className={filterId === 0 ? "" : "d-none"}
                                        header="Acciones"
                                        headerStyle={{ ...headerStyle, textAlign: "center" }}
                                        style={{ ...cellStyle, textAlign: "center", width: "100px", verticalAlign: "top", paddingBottom: 0, }}
                                        body={(rowData) => (
                                            <div
                                                className={rowData?.id_estatus_order === 20 ? "d-none" : "d-flex justify-content-center"}
                                                style={{ gap: "4px", alignItems: "flex-start" }}
                                            >
                                                <button
                                                    onClick={() => handleFilterByClient(rowData?.id_client, false, false, true)}

                                                    title="Detalle de la empresa"
                                                    style={buttonStyle}
                                                >
                                                    <i style={{ fontSize: "14px" }} className="pi pi-eye"></i>
                                                </button>
                                                <button
                                                    onClick={() => DownloadReportCxc(rowData?.id_client)}

                                                    //onClick={() => printTicket(rowData?.id_work_order)}
                                                    title="Descargar reporte de la empresa"
                                                    style={buttonStyle2}
                                                >

                                                    <i style={{ fontSize: "14px" }} className="pi pi-file-excel"></i>
                                                </button>


                                            </div>
                                        )}
                                    />

                                </DataTable>

                            </Col>
                            <Col sm="12" className={filterId === 0 ? "d-none" : 'pt-4 '} >
                                <Col sm="12" className='pt-2 pb-4 p-l-0 p-r-0' >
                                    <Col sm="12" className='p-l-0 p-r-0 pt-2 pb-5' style={{
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '10px', padding: '12px', fontSize: '12px'
                                    }} >
                                        {dataViewCompany && dataViewCompany.length > 0 && (
                                            <div style={{
                                                fontWeight: 'bold', background: '#0d3b59', color: 'white',
                                                padding: '6px', borderRadius: '8px', marginBottom: '10px',
                                                textAlign: 'center', fontSize: '12px'
                                            }}>
                                                <label style={{ fontWeight: "bold", fontSize: "12px" }}>
                                                    {dataViewCompany[0].name_client || '--'}
                                                </label>
                                            </div>

                                        )}

                                        {dataViewCompany && dataViewCompany.length > 0 && (
                                            <div>
                                                <label style={{ fontWeight: "bold", fontSize: "12px" }}>
                                                    {dataViewCompany[0].business_name || '--'}
                                                </label>
                                            </div>
                                        )}
                                        {dataViewCompany && dataViewCompany.length > 0 && (
                                            <div>
                                                <label style={{ fontWeight: "bold", fontSize: "12px" }}>
                                                    Total de estudios:   {(dataViewCompany[0].total_profiles + dataViewCompany[0].total_exams) || 0}
                                                </label>
                                            </div>
                                        )}
                                        {
                                            (valuId !== 0 && valuId !== null) && <label style={{ fontWeight: "bold", fontSize: "12px" }}>
                                                Convenio:   {valuId.label || '--'}
                                            </label>
                                        }
                                    </Col>

                                    <Row className='pt-2' >
                                        <Col sm="10">
                                            <div className='form-group'>
                                                <label className='label-dashboard' style={{ color: "#0d3b59", fontSize: "14px" }}>Buscar convenio</label>
                                                <Select
                                                    className="input-air-primary input-xs"
                                                    classNamePrefix="select"
                                                    name="client_id"
                                                    value={valuId}
                                                    options={listAgreement}
                                                    placeholder="Seleccione un convenio"
                                                    isClearable={true}
                                                    onChange={(e) => handleChangeAgreement(e)}
                                                    styles={{
                                                        control: (provided) => ({
                                                            ...provided,
                                                            fontSize: '16px',
                                                            fontWeight: 'normal',
                                                        }),
                                                        option: (provided) => ({
                                                            ...provided,
                                                            fontSize: '16px',
                                                            fontWeight: 'normal',
                                                        }),
                                                        singleValue: (provided) => ({
                                                            ...provided,
                                                            fontSize: '16px',
                                                            fontWeight: 'normal',
                                                        }),
                                                        placeholder: (provided) => ({
                                                            ...provided,
                                                            fontSize: '16px',
                                                            fontWeight: 'normal',
                                                        }),
                                                        menuPortal: (base ) => ({ ...base, zIndex: 99999 })
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                        <Col sm="2" className='pt-4' >
                                            <div style={{ display: "flex", gap: "5px", alignItems: "center", paddingTop: "6px" }}>
                                                <Button
                                                    icon="pi pi-search"
                                                    rounded
                                                    title='Busqueda global'
                                                    severity="warning"
                                                    aria-label="Search"
                                                    onClick={() => handleFilterByClient(filterId, true)}
                                                    style={{
                                                        padding: "5px 10px",
                                                        height: "35px",
                                                        width: "35px",
                                                        fontSize: "1rem",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>

                                </Col>
                            </Col>

                        </Col>
                        {
                            filterId === 0 && <Col sm="6" className='' > <br /><br /> <br />
                                <Card
                                    className="shadow-sm border height-equal pricingtable mb-0 pb-3"

                                >


                                    <Row className="p-2">
                                        <Col sm="12" className='pb-5' >
                                            <div

                                            >
                                                <ReportCompanyChart dataViewCompany={dataViewCompany} />
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        }
                        {
                            filterId !== 0 && <Col sm={filterId === 0 ? "6" : "8"}>
                                <br />< br />
                                <DataTable
                                    value={detailTransactionsByCompany}
                                    responsiveLayout="scroll"
                                    paginator
                                    rows={10}
                                    emptyMessage={
                                        <div className="text-center">
                                            <img
                                                src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                style={{ width: "25%" }}
                                                alt="Sin Muestras"
                                            />
                                            <br />
                                            <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                No hay resultados disponibles.
                                            </p>
                                        </div>
                                    }
                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                    stripedRows
                                    globalFilter={globalFilter}
                                    loading={loadingReport}
                                    dataKey="idWorkOrder"
                                    expandedRows={expandedRows}
                                    onRowToggle={(e) => setExpandedRows(e.data)}
                                    rowExpansionTemplate={rowExpansionTemplate}
                                >

                                    <Column
                                        expander={(rowData) => rowData.detailTransactionsByProfileOrExams?.length > 1}

                                        style={{
                                            width: "50px",
                                            textAlign: "center"
                                        }}
                                        headerStyle={headerStyle}
                                    />
                                    <Column
                                        body={(rowData, { rowIndex }) => rowIndex + 1}
                                        header="#"
                                        style={{
                                            ...cellStyle,
                                            textAlign: "center",
                                            width: "100px",
                                        }}
                                        headerStyle={headerStyle}
                                        sortable
                                        field="idWorkOrder"
                                    />

                                    <Column
                                        field="nameAgreement"
                                        header="Convenio"
                                        sortable
                                        style={cellStyle}
                                        headerStyle={headerStyle}
                                    />

                                    <Column
                                        field="namePatient"
                                        header="Paciente"
                                        sortable
                                        style={cellStyle}
                                        headerStyle={headerStyle}
                                    />

                                    <Column
                                        field="nim"
                                        header="NIM"
                                        sortable
                                        style={cellStyle}
                                        headerStyle={headerStyle}
                                    />

                                    <Column
                                        field="createdAt"
                                        header="Fecha"
                                        sortable
                                        style={cellStyle}
                                        headerStyle={headerStyle}
                                    />

                                    <Column
                                        header="Total Estudios"
                                        body={(row) => (
                                            <Tag
                                                value={row.detailTransactionsByProfileOrExams?.length ?? 0}
                                                severity="warning"
                                            />
                                        )}
                                        style={{
                                            ...cellStyle,
                                            textAlign: "center",
                                            width: "120px"
                                        }}
                                        headerStyle={headerStyle}
                                    />

                                    <Column
                                        header="Estudios"
                                        body={(row) => row.detailTransactionsByProfileOrExams?.[0]?.nameStudy}
                                        style={cellStyle}
                                        headerStyle={headerStyle}
                                    />

                                </DataTable>

                            </Col>
                        }

                    </Row>
                </Col>


            </Row>

        </Col>
    )
}
